import { memo } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const RedirectRouter = () => {
  const location = useLocation();
  const routes: { [key: string]: any } = {
    '/': '/resumo',
    '/vitrine': '/resumo',
    '/resumo': '/resumo'
  };

  const currentRoute = location.pathname in routes ? location.pathname : '/resumo';
  return <Navigate to={`${routes[currentRoute]}${window.location.search}`} replace={true} />;
};

export default memo(RedirectRouter);
